import React, { useCallback } from "react";
import { ControlledTextfield } from "../../../components/inputs";
import { Button } from "../../../components";

const FormTipoDeConvenio = ({
  props,
  disabled,
  handleSubmit,
  tipoDeConvenio,
  voltarParaLista,
}) => {
  const handleClickNext = useCallback(
    (values) => {
      handleSubmit(values, tipoDeConvenio.id);
    },
    [handleSubmit, tipoDeConvenio]
  );
  return (
    <div className="card spacer">
      <div className="card-body">
        <span className="card-title color-brand">Tipo de Convênio</span>
        <form onSubmit={props.handleSubmit(handleClickNext)}>
          <div className="row">
            <div className="col-12 col-md-3">
              <ControlledTextfield
                name={"tipoConvenio"}
                margin={"none"}
                disabled={disabled}
                formProps={props}
                uppercase={true}
                label={"Tipo"}
                inputProps={{ maxLength: 10 }}
              />
            </div>
            <div className="col-12 col-md-9">
              <ControlledTextfield
                name={"nome"}
                formProps={props}
                uppercase={true}
                disabled={disabled}
                label={"Nome"}
                margin={"none"}
                inputProps={{ maxLength: 40 }}
              />
            </div>
          </div>
          <div className="row spacer">
            <div className="offset-md-2 col-md-4 col-12">
              <Button
                label="Voltar"
                onClick={voltarParaLista}
                loading={tipoDeConvenio.loading}
              />
            </div>
            <div className="col-md-4 col-12">
              <Button
                label="CONFIRMAR"
                type={"submit"}
                loading={tipoDeConvenio.loading}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormTipoDeConvenio;
